import React, {
  memo
} from "react";
import {
  StyleSheet
} from "react-native";
import {
  Card
} from "@constants/Themed";
import {
  H3
} from "tamagui";
import {
  useTranslation
} from "react-i18next";
import {
  themeSelector
} from "@reduxLocal/selectors/themeSelector";

interface WelcomeHeaderWidgetProps {
  userName: string;
}

const WelcomeHeaderWidget: React.FC<WelcomeHeaderWidgetProps> = ({
  userName,
}) => {
  const {
    t
  } = useTranslation();
  const theme = themeSelector();

  return (
    <Card style={[styles.card, {
      backgroundColor: theme ? "#ffffff" : "#1e1e1e"
    }]}>
      <H3
        style={
          [
            styles.text,
            {
              color: theme ? "#000" : "#fff"
            },
          ]
        }
      >
        {t("Welcome Back")}, {userName}!
      </H3>
    </Card>
  );
};

const styles = StyleSheet.create({
  card: {
    width: "100%",
    height: "100%",
    borderRadius: 15,
    overflow: "hidden",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  text: {
    textAlign: "center",
    marginBottom: 10,
  },
});

export default memo(WelcomeHeaderWidget);
